import { BaseButton as Button } from './BaseButton';
import styled from 'styled-components';
import React, { ReactNode, useState } from 'react';
import { useAnalytics } from 'react-shisell';

const AnchorTag = styled(Button)`
  all: unset;
  padding: 0.5rem;
  cursor: pointer;
`;

interface StarLinkProps {
  rating: number;
  onStarClicked: (rating: number) => void;
  children: ReactNode;
  analyticsExtras: any;
  linkLabelText: string;
}

export const StarLink = ({ rating, onStarClicked, children, analyticsExtras, linkLabelText }: StarLinkProps) => {
  const analytics = useAnalytics();
  const [isPressed, setIsPressed] = useState(false);

  const onStarClick = () => {
    setIsPressed(true);
    analytics.dispatcher.withExtras({ ...analyticsExtras }).dispatch('SH_WEB_EVENT');
    onStarClicked(rating);
  };
  return (
    <AnchorTag aria-label={linkLabelText} aria-pressed={isPressed} tabIndex={0} onClick={onStarClick}>
      {children}
    </AnchorTag>
  );
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FiveStarSurvey/components/StarLink.tsx